
import useSettings from "../settings/useSettings.js";

import React, { useState, useEffect, Suspense, lazy } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip, Fab, Typography, IconButton, Box, CircularProgress } from '@material-ui/core';
import Assistant from '@material-ui/icons/Assistant';
import Close from '@material-ui/icons/Close';

const ChatbotInner = lazy(() => import("./ChatbotInner.js"));//lazy load so bundler will split webchat and msal into own js file

const chatbotStyles = makeStyles((theme) => ({
    container: {
        position: 'fixed',
        bottom: '0.5em',
        right: '0.5em',
        zIndex: 1000,
        opacity: 1,
        transition: 'opacity 0.3s',
        pointerEvents: 'inherit',
        background: 'transparent'
    }
}));

function Chatbot() {
    const styles = chatbotStyles();
    let settings = useSettings();
    const [bubbleOpen, setBubbleOpen] = useState(false);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    const onToggleCallback = () => {
        setBubbleOpen(!bubbleOpen);
    }

    const isSettingEnabled = settings.get('Copilot enabled');
    const isReactSnap = typeof window !== 'undefined' && navigator.userAgent === 'ReactSnap';
    const shouldHide = isReactSnap || !isMounted || !isSettingEnabled;

    return <Box className={styles.container} style={shouldHide ? { display: 'none' } : {}}>
        <ChatbotWindow isOpen={bubbleOpen} onToggle={onToggleCallback} />
        <ChatbotBubble onToggle={onToggleCallback} />
    </Box>;
}

const chatbotBubbleStyles = makeStyles((theme) => ({
    main: {
        position: "fixed",
        right: "0.5em",
        bottom: "0.5em",
        zIndex: 99,
        transition: 'transform 0.3s',
        "@media print": {
            display: "none !important"
        }
    },
    button: {
        border: "var(--black) 1px solid",
        padding: "4px",
        background: "var(--white)",
        transition: 'transform 0.3s',
        '&:hover': {
            transform: 'scale(1.05)'
        }
    },
    icon: {
        fontSize: "4em"
    }
}));
function ChatbotBubble({ onToggle }) {
    let settings = useSettings();
    const styles = chatbotBubbleStyles();
    const label = `Open ${settings.get("Copilot name") || 'Assistant'}`;

    return <Box className={styles.main}>
            <Tooltip title={label}>
                <Fab aria-label={label} onClick={onToggle} className={styles.button}>
                    <img style={{width: "3em"}} src={`${process.env.PUBLIC_URL}/media/bot.svg`} /> 
                </Fab>
            </Tooltip>
        </Box>;
}

const chatbotWindowStyles = makeStyles((theme) => ({
    window: {
        position: 'fixed',
        bottom: '45px',
        right: '60px',
        width: '0px',
        height: '0px',
        backgroundColor: 'var(--white)',
        borderRadius: '8px',
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        zIndex: 1000,
        transition: 'width 0.3s, height 0.3s, bottom 0.3s, right 0.3s',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        border: '0px solid var(--black)',
        '&.open': {
            bottom: '90px',
            right: '20px',
            width: '600px',
            height: '450px',
            borderWidth: '1px'
        }
    },
    header: {
        padding: '5px',
        backgroundColor: 'var(--brightBlue)',
        color: 'var(--persistWhite)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid var(--black)',
        '& h4': {
            padding: 0,
            margin: 0
        }
    },
    body: {
        flexGrow: 1,
        padding: '15px',
        paddingBottom: '0',
        overflowY: 'auto',
        background: 'transparent',
        position: 'relative'
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%'
    }
}));

function ChatbotWindow({ isOpen, onToggle }) {
    const styles = chatbotWindowStyles();
    let settings = useSettings();
    const [hasOpened, setHasOpened] = useState(false);
    const headerText = settings.get("Copilot name") || 'Assistant';
    
    useEffect(() => {
        if(isOpen && !hasOpened)
            setHasOpened(true);
    }, [isOpen]);
    
    return <Box className={styles.window + (isOpen ? ' open' : '')}>
        <Box className={styles.header}>
            <Typography variant="h4">
            <img style={{width:'3em', marginTop: "-0.5em", verticalAlign: 'middle', marginRight: '0.5em'}} src={`${process.env.PUBLIC_URL}/media/bot.svg`} />
            {headerText}
            </Typography>
            <IconButton aria-label="close" onClick={onToggle} style={{color: 'var(--persistWhite)'}} ><Close /></IconButton>
        </Box>
        {hasOpened && <Box className={styles.body}>
            <Suspense fallback={<CircularProgress />}><ChatbotInner /></Suspense>
        </Box>}
    </Box>;
}

export default Chatbot;